'use client';

import { RtButton } from '@dpa/react-buttons';
import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { flushSync } from 'react-dom';
import { articlePrintClickEvent } from '@/_analytic/events/article-print-click-event';
import { IMaterial } from '@/_types';
import { useMaterialAnalyticData } from '@/_analytic/hooks/use-material-analytic-data';
import styles from './index.module.scss';

const BLOCK_NAME = 'Print-Button';
const cn = classnames.bind(styles);

export type TPrintButtonProps = {
  materialName: IMaterial['title'];
  materialId: IMaterial['id'];
  materialCategoryId?: string;
};

export const PrintButton = ({
  materialName,
  materialId,
  materialCategoryId,
}: TPrintButtonProps) => {
  const translations = useTranslations('article');
  const text = translations('printButtonText');

  const materialAnalyticData = useMaterialAnalyticData({
    materialId,
    materialCategoryId,
    materialTitle: materialName,
  });

  const handlePrint = () => {
    articlePrintClickEvent(materialAnalyticData);

    flushSync(() => window.dispatchEvent(new Event('beforeprint')));

    window.print();
  };

  return (
    <div className={cn(BLOCK_NAME)}>
      <RtButton
        label={text}
        use="primary"
        onClick={handlePrint}
        radius="primary"
        size="md"
      />
    </div>
  );
};
